<template>
  <settings-modal
    class="payment-aml-tracking-mark-edit-modal t-aml-tracking-mark-edit-modal"
  >
    <template slot="heading">Edit documents request tracking mark</template>
    <template>
      <v-select
        v-model="form.trackingMark"
        class="t-tracking-mark-select"
        :items="trackingMarkOptions"
        item-text="name"
        item-value="value"
        label="Select tracking mark"
        :error-messages="getValidationErrorMessage('trackingMark')"
      />
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="isConfirmButtonDisabled"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Models
  import Payment from '@/models/Payment'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentAmlTrackingMarkEditModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { trackingMark: null },
        requiredFields: ['trackingMark'],
        updateAmlTrackingMarkApiRequest: new ApiRequest(PaymentApi.updateAmlTrackingMark)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      currentTrackingMark () {
        return this.modal.data.trackingMark
      },
      trackingMarkOptions () {
        return Payment.amlTrackingMarkOptions
      },
      error () {
        return this.updateAmlTrackingMarkApiRequest.error
      },
      isConfirmButtonDisabled () {
        return this.updateAmlTrackingMarkApiRequest.loading || !this.isFormFilled || this.form.trackingMark === this.currentTrackingMark
      }
    },
    created () {
      this.setFieldValue('trackingMark', this.currentTrackingMark)
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.updateAmlTrackingMarkApiRequest.execute(this.paymentId, this.parsedFormInput.trackingMark)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)

            this.showModal({
              name: 'SuccessFlashModal',
              data: {
                message: 'Documents tracking mark has been successfully updated'
              }
            })
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
